import React, { createContext, useContext, useState } from "react";

const IneConfigContext = createContext();

export const IneConfigProvider = ({ children }) => {
  //Gestion del contenido de los Alert
  const [message, setMessage] = useState("Esto un mensaje de prueba");
  const [alertType, setAlertType] = useState("success");

  //Gestion del Alert del Header
  const [showAlertHeader, setShowAlertHeader] = useState(false);
  const openAlertHeader = () => {
    setShowAlertHeader(true);
  };
  const closeAlertHeader = () => {
    setShowAlertHeader(false);
  };

  const [apiSuccess, setApiSuccessSuccess] = useState(false);
  const changeApiSuccess = () => {
    setApiSuccessSuccess(!apiSuccess);
  };
  return (
    <IneConfigContext.Provider
      value={{
        apiSuccess,
        changeApiSuccess,
        alertType,
        setAlertType,
        setMessage,
        message,
        openAlertHeader,
        closeAlertHeader,
        showAlertHeader,
      }}
    >
      {children}
    </IneConfigContext.Provider>
  );
};

export const useIneConfig = () => {
  return useContext(IneConfigContext);
};
